<template>
  <div class="instruction">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-textarea
      v-model="text"
      @change="validateT"
      outlined
      hide-details
      :label="$t('validate-audit.label-1')"
      clear-icon="icon-delete delete-icon"
      clearable
    ></v-textarea>

    <v-switch v-model="showSecretText" inset></v-switch>

    <v-textarea
      v-if="showSecretText"
      v-model="secretText"
      @change="validateC"
      outlined
      hide-details
      :label="$t('validate-audit.label-2')"
      clear-icon="icon-delete delete-icon"
      clearable
    ></v-textarea>
  </div>
</template>

<script>
import { validT } from '@/js/survey/validate/validT'
import { validC } from '@/js/survey/validate/validC'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    answerid: String,
    question: Array | Object,
    infoQuestion: Array | Object
  },
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      text: this.infoQuestion.validt ? this.infoQuestion.validt : '',
      showSecretText: false,
      secretText: this.infoQuestion.validc ? this.infoQuestion.validc : '',
      httpalert: false
    }
  },

  methods: {
    validateT () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        answerid: this.answerid,
        id: this.question.id,
        // module: this.question.id,
        value: this.text,
        key: this.$route.params.validkey
      }

      validT(params)
        .then(() => {})
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    validateC () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        answerid: this.answerid,
        id: this.question.id,
        // module: this.question.id,
        value: this.secretText,
        key: this.$route.params.validkey
      }

      validC(params)
        .then(() => {})
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
